import { render, staticRenderFns } from "./OrderResourceItem.vue?vue&type=template&id=3463dfdc"
import script from "./OrderResourceItem.vue?vue&type=script&lang=js"
export * from "./OrderResourceItem.vue?vue&type=script&lang=js"
import style0 from "./OrderResourceItem.vue?vue&type=style&index=0&id=3463dfdc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports